window.MemberName = (function () {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            messages: {
                invalidLastName: '#invalid-member-name',
                invalidFormMessage: '#invalid-form-message'
            },
            textBox: {
                memberFirstName: '#first-name-disabled',
                memberLastName: '#last-name-input'
            },
            memberTitle: '#member-form-title option:selected'
        },
        urls: {
            updateSession: '/api/sitecore/MyAccount/UpdateSession',
            confirmNamePageUrl: '/my-account/details/name/confirm',
            errorPageUrl: '/error/error-page',
            validatePersonalDetails: '/api/sitecore/MyAccount/ValidatePersonalDetails'
        },
        constants: {
            NoUpdateMessageCode: 'NoUpdate',
            ValidSurnameMessageCode: 'ValidSurname'
        },
        func: {
            init: function () {
                self.func.bindings();
                $(self.elements.messages.invalidLastName).hide();
                $(self.elements.messages.invalidFormMessage).hide();
            },
            bindings: function () {
                $('#member-form').on('submit', self.func.handleSaveMemberName);
            },
            handleSaveMemberName: function (event) {
                event.preventDefault();
                $(self.elements.messages.invalidLastName).hide();
                $(self.elements.messages.invalidFormMessage).hide();
                const memberLastName = $(self.elements.textBox.memberLastName).val();
                const memberTitle = $(self.elements.memberTitle).val();

                // AJAX call to validate surname.
                $.ajax({
                    type: 'POST',
                    url: self.urls.validatePersonalDetails,
                    data: {title: memberTitle, surname: memberLastName},
                    success: self.func.validatePersonalDetailsSuccess,
                    error: self.func.validatePersonalDetailsError
                });
            },
            validatePersonalDetailsSuccess: function (data) {
                if(data?.messageCode === self.constants.NoUpdateMessageCode){
                    $(self.elements.messages.invalidFormMessage).show();
                    return;
                }
                if (data?.messageCode === self.constants.ValidSurnameMessageCode) {
                    const memberLastName = $(self.elements.textBox.memberLastName).val();
                    const memberTitle = $(self.elements.memberTitle).val();
                    // AJAX call to update the session
                    $.post(self.urls.updateSession, {
                        title: memberTitle,
                        lastName: memberLastName
                    })
                        .done(function () {
                            window.location.href = self.urls.confirmNamePageUrl;
                        })
                        .fail(function () {
                            window.location.href = self.urls.errorPageUrl;
                        });
                } else {
                    $(self.elements.messages.invalidLastName).show();
                }
            },
            validatePersonalDetailsError: function () {
                window.location.href = self.urls.errorPageUrl;
            }
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function () {
    if ('memberName' === $('#member-form').data('feature')) {
        window.MemberName.Init();
    }
});
